import {Injectable} from '@angular/core';
import {GeneralServicesImplService} from '../../../services/general-services-impl.service';
import {HttpClient} from '@angular/common/http';
import * as servers from '../../../services/api/servers';
import {urls} from '../../../services/api/urls';
import {Observable} from 'rxjs';
import {ProjectConstants} from '../../project-constants';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class RateTypeAnagrafService extends GeneralServicesImplService {

  constructor(http: HttpClient) {
    super(http);
  }

  baseUrl: string = servers.apiUrl + urls.rateType;

  getPage(filter: any, offset?: any): Observable<any> {
    const url = this.baseUrl + this.LINKS.PAGE;
    const body =  offset ? JSON.stringify(offset) : null;
    const header = ProjectConstants.returnGeneralHeader();
    return this.http.post( url, body, {headers: header, responseType: 'json', params: filter})
      .pipe(
        // map (data => data) da inserire gestione errori
      );
  }

  getList(filter?: any): Observable<any> {
    const url = this.baseUrl + this.LINKS.GET_LIST;
    const body = filter ? filter : null;
    const header = ProjectConstants.returnGeneralHeader();
    return this.http.post( url, body, {headers: header, responseType: 'json'})
      .pipe(
        // map (data => data) da inserire gestione errori
      );
  }

  softDelete(id: number): Observable<any> {
    const url = this.baseUrl  + this.LINKS.SOFT_DELETE + id;
    const header = ProjectConstants.returnGeneralHeader();
    return this.http.delete(url, {headers: header, responseType: 'json'})
      .pipe(
        map (data => data)
      );
  }
}

